import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "light" | "dark";
export type WallpaperId = "default" | "papaya" | "leaf" | "dusk";

type DialerPosition = { x: number; y: number };

type UiState = {
  theme: Theme;
  wallpaper: WallpaperId;
  sidebarOpen: boolean;
  dialerOpen: boolean;
  dialerMinimized: boolean;
  dialerPosition: DialerPosition;
  setTheme: (theme: Theme) => void;
  setWallpaper: (wallpaper: WallpaperId) => void;
  toggleTheme: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  openDialer: () => void;
  closeDialer: () => void;
  toggleDialerMinimized: () => void;
  setDialerMinimized: (minimized: boolean) => void;
  setDialerPosition: (position: DialerPosition) => void;
};

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: "light",
      wallpaper: "default",
      sidebarOpen: true,
      dialerOpen: false,
      dialerMinimized: false,
      dialerPosition: { x: 72, y: 96 },
      setTheme: (theme) => set({ theme }),
      setWallpaper: (wallpaper) => set({ wallpaper }),
      toggleTheme: () =>
        set((state) => ({
          theme: state.theme === "light" ? "dark" : "light",
        })),
      setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
      toggleSidebar: () =>
        set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      openDialer: () => set({ dialerOpen: true, dialerMinimized: false }),
      closeDialer: () => set({ dialerOpen: false, dialerMinimized: false }),
      toggleDialerMinimized: () =>
        set((state) => ({ dialerMinimized: !state.dialerMinimized })),
      setDialerMinimized: (dialerMinimized) => set({ dialerMinimized }),
      setDialerPosition: (dialerPosition) => set({ dialerPosition }),
    }),
    {
      name: "papaya-web-ui",
      partialize: (state) => ({
        theme: state.theme,
        wallpaper: state.wallpaper,
        sidebarOpen: state.sidebarOpen,
        dialerPosition: state.dialerPosition,
      }),
    },
  ),
);
